// formatBytes Перевод байт в формат чтения.
export const formatBytes = (bytes: number, decimals = 2): string => {
  // if (!+bytes) return '0 Bytes'
  if (!+bytes) return '0 Байт'
  const k = 1024 as const
  const dm: number = decimals < 0 ? 0 : decimals
  // const sizes: string[] = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  const sizes: string[] = ['Байт', 'КБ', 'МБ', 'ГБ', 'ТБ', 'ПБ', 'EB', 'ZB', 'YB']
  const i: number = Math.floor(Math.log(bytes) / Math.log(k))
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}
